import { useTranslate } from "@similarweb/i18n-provider";
import { SegmentedControl, Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { AlertTabId } from "./config";
import { TABS_WITHOUT_METRICS, VIEW_MODES } from "./viewModeConfig";
import type { AlertViewMode } from "./viewModeConfig";

type ViewModeToggleProps = {
    currentTab: AlertTabId;
    currentViewMode: AlertViewMode;
    onViewModeChange: (value: string) => void;
};

export const ViewModeToggle = ({ currentTab, currentViewMode, onViewModeChange }: ViewModeToggleProps) => {
    const { translate } = useTranslate();

    const isMetricsDisabled = TABS_WITHOUT_METRICS.includes(currentTab);

    return (
        <Flex
            gap="8px"
            alignItems="center"
            data-automation="alerts-view-mode-toggle"
        >
            <Text fontVariant="body2">{translate("activation.alerts.view-mode.label")}</Text>
            <SegmentedControl
                value={currentViewMode}
                onValueChange={onViewModeChange}
                data-automation="alerts-view-mode-segmented-control"
            >
                {VIEW_MODES.map((mode) => {
                    const isDisabled = mode.id === "metrics" && isMetricsDisabled;
                    const label = translate(mode.translationKey);

                    return (
                        <Tooltip
                            key={mode.id}
                            content={translate("activation.alerts.view-mode.metrics.disabled.tooltip")}
                            enabled={isDisabled}
                        >
                            <SegmentedControl.Item
                                value={mode.id}
                                label={label}
                                disabled={isDisabled}
                            />
                        </Tooltip>
                    );
                })}
            </SegmentedControl>
        </Flex>
    );
};
